import React from 'react';

const variantClasses = {
  default: 'bg-primary text-primary-foreground border-transparent',
  secondary: 'bg-muted text-foreground border-transparent',
  outline: 'bg-transparent text-foreground border-border',
  destructive: 'bg-destructive text-destructive-foreground border-transparent',
  success: 'bg-success-muted text-success-strong border-transparent',
  danger: 'bg-danger-muted text-danger-strong border-transparent',
  warning: 'bg-warning-muted text-warning-strong border-warning/40',
  info: 'bg-info-muted text-info-strong border-transparent',
};

export function Badge({ variant = 'default', className = '', children, ...rest }) {
  const base = 'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold leading-tight';
  return (
    <span className={`${base} ${variantClasses[variant] || ''} ${className}`} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
